import script from "./SwapBillingPeriod.vue?vue&type=script&setup=true&lang=js"
export * from "./SwapBillingPeriod.vue?vue&type=script&setup=true&lang=js"

import "./SwapBillingPeriod.vue?vue&type=style&index=0&id=25e3168b&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e3168b"]])

export default __exports__